export default "__VITE_ASSET__DsTJzYJw__"